import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    scroll(opt, tar) {
      return $(`
      <li class="select-dropdown__item">
        <span id="span"></span>
      </li>`)
    }
  },
  updater: {
    // 基本功能: 内部文字
    label(value, opt, tar, node) {
      const { span } = tar.members
      span.html(value)
    },
    // 基本功能: 内部文字
    value(value, opt, tar, node) {
      tar.unit.attr('value', value)
    },
    // 基本功能: 内部文字
    visible(value, opt, tar, node) {
      // const { checkbox } = tar.members
      // if (value || value === '') {
      //   tar.unit.addClass('is-disabled')
      //   checkbox.map((obj) => {
      //     obj.disabled = true
      //   })
      // } else {
      //   tar.unit.removeClass('is-disabled')
      //   checkbox.map((obj) => {
      //     obj.disabled = false
      //   })
      // }
    },
    // 基本功能: 选中
    selected(value, opt, tar, node) {
      if (value) {
        tar.unit.addClass('selected')
      } else {
        tar.unit.removeClass('selected')
      }
    },
    // 基本功能: 内部文字
    disabled(value, opt, tar, node) {
      if (value) {
        tar.unit.addClass('is-disabled')
      } else {
        tar.unit.removeClass('is-disabled')
      }
    },
    // 基本功能: 内部文字
    hover(value, opt, tar, node) {
      // const { checkbox } = tar.members
      // if (value || value === '') {
      //   tar.unit.addClass('is-disabled')
      //   checkbox.map((obj) => {
      //     obj.disabled = true
      //   })
      // } else {
      //   tar.unit.removeClass('is-disabled')
      //   checkbox.map((obj) => {
      //     obj.disabled = false
      //   })
      // }
    }
  }
}

export default class Option extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      visible: true, // 基本功能: 可见
      selected: false, // 基本功能: 选中
      disabled: false, // 基本功能: 禁用/可用
      // hover: false, // 基本功能: 悬浮
      value: '', // 基本功能 : 值
      label: '' // 基本功能: 内部文字
    }
    this.events = {
      click: null,
      hover: null
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.scroll(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    this.unit.click($.proxy(this.click, this))
    this.unit.hover($.proxy(this.hover, this))
  }
}
